import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import DownloadExcel, {
  exportToExcel,
  getRecords,
} from "../../../services/api.service";
import { CSVLink } from "react-csv";

const ProjectDetails = () => {
  const { id } = useParams();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingData, setLoadingData] = useState(false);
  const recordsPerPage = 10;

  useEffect(() => {
    fetchReports();

    const handleStorageChange = () => {
      fetchReports();
    };

    window.addEventListener("dashboardUpdate", handleStorageChange);
    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, []);

  const fetchReports = async () => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const project_id = JSON.parse(dashboard_details).project_id;
      let payload = {
        modelName: "projects",
        relations: [
          {
            module: "company_masters",
            moduleAs: "company",
          },
        ],
      };

      if (project_id.length > 0) {
        payload.whereCondition = payload.whereCondition || {};
        payload.whereCondition.id = { in: project_id };
      }

      let responseData = await getRecords(payload, "/getRecords");
      if (responseData.code === 1 && responseData.data.length > 0) {
        setData([...responseData.data]);
      } else {
        setData([]);
      }
      setLoadingData(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e) => {
    setSearchKeyword(e.target.value);
    setCurrentPage(1);
  };

  const filteredItems = data.filter((row) =>
    row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);

  // export code
  const columns = [
    { label: "Sr. No", key: "srNo" },
    { label: "Project Name", key: "project_name" },
    { label: "Project Code", key: "project_code" },
    { label: "Customer Name", key: "company_name" },
  ];

  const csvData = filteredItems.map((row, index) => ({
    srNo: index + 1,
    project_name: row?.project_name || "N/A",
    project_code: row?.project_code || "N/A",
    company_name: row?.company?.company_name || "N/A",
  }));

  const handleExportData = () => {
    DownloadExcel({
      fileName: "ProjectDetails",
      columns: columns,
      data: csvData,
      cellColor: true,
    });
  };

  return (
    <CustomForm
      title="PROJECT REPORT"
      id={id}
      noBackButton
      noSubmitButton
      loadingData={loadingData}
    >
      <Row className="mt-1">
        <Col lg={12}>
          <div className="d-flex justify-content-between align-items-center m-0">
            <div className="app-search d-flex mt-0 w-25">
              <input
                type="search"
                className="form-control"
                placeholder="Search .."
                value={searchKeyword}
                onChange={handleInputChange}
                style={{
                  width: "15rem",
                  padding: "8px 15px",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div onClick={handleExportData} className="btn btn-success">
              Download CSV
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table
                className="table table-hover mb-0"
                style={{ border: "1px solid black" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "#8AC1E8",
                  }}
                >
                  <tr>
                    <th>Sr. No</th>
                    <th>Project Name</th>
                    <th>Project Code</th>
                    <th>Customer Name</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.length > 0 ? (
                    currentRecords.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                        }}
                      >
                        <td>{indexOfFirstRecord + index + 1}</td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                            title={row?.project_name || "N/A"}
                          >
                            {row?.project_name || "N/A"}
                          </div>
                        </td>{" "}
                        <td>{row?.project_code || "N/A"}</td>
                        <td>{row?.company?.company_name || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-primary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-primary"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default ProjectDetails;
